import Reflux from 'reflux';

export default Reflux.createActions([
	'featureHit',
	'featureUnhit',
	'disable',
	'enable',
	'zoomOut',
]);
